/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import styles from './EmailButton.module.css';

function EmailButton({
  text = 'EmailButton',
  onClick = () => {},
  disabled = false,
  width = '230px',
  height = '40px',
}) {
  const [isLoading, setIsLoading] = useState(false);

  return (

    <button
      type="button"
      className={styles.hoverButton}
      disabled={disabled || isLoading}
      style={{
        width,
        height,
        borderRadius: '20px',
        border: '1px solid var(--main1Border)',
        background: 'var(--main1)',
        color: disabled || isLoading ? 'grey' : 'var(--visible)',
        cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
        padding: '0px 10px 0px 10px',
        display: 'flex',
        fontSize: '14px',
        fontWeight: 600,
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={async () => {
        setIsLoading(() => true);
        await onClick();
        setIsLoading(() => false);
      }}
    >
      <p style={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0px',
        width,
        maxWidth: '230px',
      }}
      >
        {text}
      </p>
    </button>
  );
}
export default EmailButton;
